import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  useLocation,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "./components/Header/Header";
import ActionBar from "./components/ActionBar/ActionBar";
import Login from "./components/Login/Login";
import Register from "./components/Register/Register";
import Dashboard from "./components/Dashboard/Dashboard";
import AdmissionForm from "./components/Admission/AdmissionForm/AdmissionForm";
import AdmissionHome from "./components/Admission/AdmissionHome/AdmissionHome";
import AdmissionList from "./components/Admission/AdmissionList/AdmissionList";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import StudentDetails from "./components/StudentDetails/StudentDetailsHome/StudentDetailsHome";
import StudentUpdateForm from "./components/StudentDetails/StudentUpdateForm/StudentUpdateForm";
import FeesPaymentHome from "./components/FeesPayment/FeesPaymentHome/FeesPaymentHome";
import FeePaymentForm from "./components/FeesPayment/FeesPaymentForm/FeesPaymentForm";
import FeesPaymentClass from "./components/FeesPayment/FeesPaymentClassList/FeesPaymentClassList";
import FeesPaymentList from "./components/FeesPayment/FeesPaymentMonthList/FeesPaymentMonthList";
import StudentDetailsClassList from "./components/StudentDetails/StudentDetailsClassList/StudentDetailsClassList";
import StudentDetailsView from "./components/StudentDetails/StudentDetailsView/StudentDetailsView";
import StaffDetailsList from "./components/StaffDetails/StaffDetailsList/StaffDetailsList";
import StaffDetailsForm from "./components/StaffDetails/StaffDetailsForm/StaffDetailsForm";
import StaffDetailsUpdateForm from "./components/StaffDetails/StaffDetailsUpdateForm/StaffDetailsUpdateForm";
import ExaminationHome from "./components/Examination/ExaminationHome/ExaminationHome";
import ExaminationClassList from "./components/Examination/ExaminationClassList/ExaminationClassList";
import ExaminationStudentList from "./components/Examination/ExaminationStudentList/ExaminationStudentList";
import ExaminationMarksUpdate from "./components/Examination/ExaminationMarksUpdate/ExaminationMarksUpdate";
import ExaminationMarksView from "./components/Examination/ExaminationMarksView/ExaminationMarksView";
import Footer from "./components/Footer/Footer";
import Home from "./components/HomePage/Home/Home";
import Contact from "./components/HomePage/Contact/Contact";
import Team from "./components/HomePage/Team/Team";
import Gallery from "./components/HomePage/Gallery/Gallery";
import StaffDetailsHome from "./components/StaffDetails/StaffDetailsHome/StaffDetailsHome";
import FeeReceipt from "./components/Downloadables/FeeReceipt/FeeReceipt";
import Admission from "./components/HomePage/Admission/Admission";
import Error from "./components/HomePage/Error/Error";
import StudentDetailsPrint from "./components/Downloadables/StudentDetailsPrint/StudentDetailsPrint";
import AdmissionSlip from "./components/Downloadables/AdmissionSlip/AdmissionSlip";
import MarksheetPrint from "./components/Downloadables/MarksheetPrint/MarksheetPrint";
import Devsphire from "./components/HomePage/Devsphire/Devsphire";

const AppLayout = () => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const isContact = location.pathname === "/contact";
  const isTeam = location.pathname === "/team";
  const isGallery = location.pathname === "/gallery";
  const isAdmission = location.pathname === "/admission";
  const isFeeReceipt = location.pathname.startsWith("/erp/fee-receipt/");
  const isStudentDetailsPrint = location.pathname.startsWith("/erp/student/");
  const isAdmissionSlip = location.pathname.startsWith("/erp/admission-slip/");
  const isMarksheetPrint = location.pathname.startsWith("/erp/marksheet/");
  const isDevsphire = location.pathname === "/devsphire";

  return (
    <>
      <ToastContainer />
      {!isHomePage &&
        !isContact &&
        !isTeam &&
        !isGallery &&
        !isFeeReceipt &&
        !isAdmission &&
        !isStudentDetailsPrint &&
        !isAdmissionSlip &&
        !isMarksheetPrint &&
        !isDevsphire && <Header />}
      {!isHomePage &&
        !isContact &&
        !isTeam &&
        !isGallery &&
        !isAdmission &&
        !isDevsphire && <Outlet />}
      {!isHomePage &&
        !isContact &&
        !isTeam &&
        !isGallery &&
        !isAdmission &&
        !isFeeReceipt &&
        !isStudentDetailsPrint &&
        !isAdmissionSlip &&
        !isMarksheetPrint &&
        !isDevsphire && <Footer />}
      {isHomePage && <Home />}
      {isContact && <Contact />}
      {isTeam && <Team />}
      {isGallery && <Gallery />}
      {isAdmission && <Admission />}
      {isDevsphire && <Devsphire />}
    </>
  );
};

// Layout for protected routes to include ActionBar
const ProtectedLayout = () => {
  const isFeeReceipt = location.pathname.startsWith("/erp/fee-receipt/");
  const isStudentDetailsPrint = location.pathname.startsWith("/erp/student/");
  const isAdmissionSlip = location.pathname.startsWith("/erp/admission-slip/");
  const isMarksheetPrint = location.pathname.startsWith("/erp/marksheet/");
  return (
    <>
      {!isFeeReceipt &&
        !isStudentDetailsPrint &&
        !isAdmissionSlip &&
        !isMarksheetPrint && <ActionBar />}
      <Outlet />
    </>
  );
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    children: [
      // Protected Routes
      {
        element: (
          <ProtectedRoute>
            <ProtectedLayout />
          </ProtectedRoute>
        ),
        children: [
          { path: "/erp", element: <Dashboard /> },
          { path: "/erp/students", element: <StudentDetails /> },
          { path: "/erp/admissions", element: <AdmissionHome /> },
          { path: "/erp/admissions/form", element: <AdmissionForm /> },
          { path: "/erp/admissions/list", element: <AdmissionList /> },
          { path: "/erp/students/update/:id", element: <StudentUpdateForm /> },
          { path: "/erp/fees", element: <FeesPaymentHome /> },
          {
            path: "/erp/fees/payment/class/:class_number",
            element: <FeesPaymentClass />,
          },
          {
            path: "/erp/fees/payment/details/:id",
            element: <FeesPaymentList />,
          },
          { path: "/erp/fees/payment/:id", element: <FeePaymentForm /> },
          {
            path: "/erp/students/details/class/:class_number",
            element: <StudentDetailsClassList />,
          },
          {
            path: "/erp/students/details/class/:class_number/:id",
            element: <StudentDetailsView />,
          },
          {
            path: "/erp/staffs/add",
            element: <StaffDetailsForm />,
          },
          {
            path: "/erp/staffs",
            element: <StaffDetailsHome />,
          },
          {
            path: "/erp/staffs/list",
            element: <StaffDetailsList />,
          },
          {
            path: "/erp/staffs/edit/:id",
            element: <StaffDetailsUpdateForm />,
          },
          { path: "/erp/examinations", element: <ExaminationHome /> },
          {
            path: "/erp/examinations/:exam_name",
            element: <ExaminationClassList />,
          },
          {
            path: "/erp/examinations/:exam_name/class/:class_number",
            element: <ExaminationStudentList />,
          },
          {
            path: "/erp/examinations/:exam_name/class/:class_number/:student_id/update",
            element: <ExaminationMarksUpdate />,
          },
          {
            path: "/erp/examinations/:exam_name/class/:class_number/:student_id/view",
            element: <ExaminationMarksView />,
          },
          { path: "/erp/fee-receipt/:id", element: <FeeReceipt /> },
          { path: "/erp/student/print/:id", element: <StudentDetailsPrint /> },
          { path: "/erp/admission-slip/:id", element: <AdmissionSlip /> },
          {
            path: "/erp/marksheet/print/:id/:exam_name",
            element: <MarksheetPrint />,
          },
        ],
      },
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "/admission",
        element: <Admission />,
      },
      {
        path: "/team",
        element: <Team />,
      },
      {
        path: "/gallery",
        element: <Gallery />,
      },
      {
        path: "/devsphire",
        element: <Devsphire />,
      },
      // Public Routes
      { path: "/erp/login", element: <Login /> },
      { path: "/erp/register", element: <Register /> },
    ],
    errorElement: <Error />,
  },
]);

export default function App() {
  return <RouterProvider router={router} />;
}
